module.exports = {"title_homepage":"主页"}


//////////////////
// WEBPACK FOOTER
// ./src/components/default.json
// module id = /2xs
// module chunks = 1